/**
 * Unified Sentry metadata (web + Chrome extension, same project).
 *
 * | Tag | Web | Extension |
 * | --- | --- | --- |
 * | `sukha.client` | `web` | `chrome_extension` |
 * | `sukha.extension_context` | — | `service_worker` / `popup` / `content_script` |
 * | `stack_contains_chrome_extension` | when mixed stacks | — |
 * | `stack_contains_sukha_extension` | Sukha extension frames in stack | — |
 *
 * Discover examples: `sukha.client:chrome_extension` or `stack_contains_chrome_extension:true`
 * Extension release: `nirvana-chrome-extension@<manifest.version>`
 */
/** Shared Sukha Sentry project DSN (web + Chrome extension). */
export const SUKHA_SENTRY_DSN =
  process.env.NEXT_PUBLIC_SENTRY_DSN ??
  "https://2ebb3d8b7236008979d7014804182de0@o4509781592440832.ingest.us.sentry.io/4509781569896448";

/** Published Chrome Web Store extension id — used to tag mixed page/extension stacks. */
export { CHROME_EXTENSION_ID as SUKHA_CHROME_EXTENSION_ID } from "@/constants/chromeExtensionId";

export const SUKHA_SENTRY_CLIENT_WEB = "web" as const;
export const SUKHA_SENTRY_CLIENT_CHROME_EXTENSION = "chrome_extension" as const;
